import { Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RoleForm from "./RoleForm";

const RoleModal = ({ open, handleClose, handleData, fetchRoleList }) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <RoleForm
        handleClose={handleClose}
        handleData={handleData}
        fetchRoleList={fetchRoleList}
      />
    </Dialog>
  );
};

export default RoleModal;
